import { Builder } from '@builder.io/sdk';
import ContactComponent from './ContactComponent';

const ContactComponentConfig = {
  name: 'ContactComponent',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Enter Title...',
    },
    {
      name: 'content',
      type: 'richText',
      defaultValue: 'Enter content here...',
    },
    {
      name: 'isMarketingPreferences',
      friendlyName: 'Is Marketing Preferences',
      type: 'boolean',
      defaultValue: false,
    },
  ],
};

Builder.registerComponent(ContactComponent, ContactComponentConfig);
